module.exports = __webpack_public_path__ + "img/logo_color.53b3bed0.png";